export default class LoaderService {
  static showLoader() {
    document.querySelector(".loaderWrapper")?.classList.remove("d-none");
  }

  static hideLoader() {
    document.querySelector(".loaderWrapper")?.classList.add("d-none");
  }
}
